// @ts-nocheck
import { matchPath } from 'react-router-dom';
import { concatWith } from './render';

const ROUTES = {
    LOGIN: {
        path: '/login',
    },
    OTP: {
        path: '/otp',
    },
    HOME: {
        path: '/',
    },
    TEMPLATES: {
        path: '/templates',
    },
    TEMPLATES_MBN: {
        path: `mbn`,
    },
    TEMPLATES_CODING: {
        path: `coding`,
    },
    TEMPLATES_MARKET_GROUPS: {
        path: `market-groups`,
    },
    TEMPLATES_BET_ACCEPTANCE: {
        path: `bet-acceptance`,
    },
    TEMPLATES_LOCK_COMBINATIONS: {
        path: `combination-locks`,
    },
    TEMPLATES_MARKETS: {
        path: `markets`,
    },
    TEMPLATES_MARKET_DESCRIPTIONS: {
        path: `market-descriptions`,
    },
    EVENTS_PREMATCH: {
        path: '/events/pre-match',
    },
    EVENTS_LIVE: {
        path: '/events/live',
    },
    EVENTS_COMMON: {
        path: '/events/:type',
    },
    VIEW_EVENT: {
        path: '/events/:type/:eventId',
    },
    BETS_MONITOR: {
        path: '/bets-monitor',
    },
    QUICK_SEARCH: {
        path: '/quick-search',
    },
    BET_HISTORY: {
        path: '/bets-history',
    },
    VOUCHERS_HISTORY: {
        path: '/voucher-history',
    },
    GAMING_ACTIVITY: {
        path: '/gaming-activity',
    },
    FINANCIAL_PERFORMANCE: {
        path: '/financial-performance',
    },
    SALE_TICKETS: {
        path: '/sale-ticket-reports',
    },
    RETAIL: {
        path: '/accounts/retail',
    },
    CASHIER_LOGS: {
        path: '/logs/cashiers/:cashierId',
    },
    USERS: {
        path: '/accounts/users',
    },
    MOBILE_USERS: {
        path: '/accounts/mobile-users',
    },
    ACCOUNTING_PERIOD: {
        path: '/accounting-period',
    },
    MESSAGE_LIST: {
        path: '/messages',
    },
    VIEW_MESSAGE: {
        path: '/messages/:messageId',
    },
    REPRINT_REQUESTS: {
        path: '/reprint-requests',
    },
    MENU_MANAGEMENT: {
        path: '/menu-management',
    },
    PAYMENT_BLOCK: {
        path: '/payment-block',
    },
    PAYMENT_BLOCK_CASHIERS: {
        path: '/payment-block/cashiers',
    },
    PAYMENT_BLOCK_MARKETS: {
        path: '/payment-block/markets',
    },
    SETTLEMENT: {
        path: '/settlement',
    },
    SETTLEMENT_TICKETS: {
        path: 'tickets',
    },
    SETTLEMENT_EVENTS: {
        path: 'events',
    },
    SETTLEMENT_MARKETS: {
        path: 'markets',
    },
    CASHOUT_BLOCK: {
        path: '/cashout-block',
    },
    CASHOUT_BLOCK_MARKETS_AND_LEAGUES: {
        path: 'markets-leagues',
    },
    CASHOUT_BLOCK_EVENTS: {
        path: 'events',
    },
    REALTIME_REPORTS_CONFIG: {
        path: '/realtimeReportsConfig',
    },
    REALTIME_REPORTS_CONFIG_TOURNAMENTS: {
        path: '/realtimeReportsConfig/tournaments',
    },
    REALTIME_REPORTS_CONFIG_EVENTS: {
        path: '/realtimeReportsConfig/events',
    },
    REALTIME_REPORTS_CONFIG_MARKETS: {
        path: '/realtimeReportsConfig/markets',
    },
    REALTIME_REPORTS: {
        path: '/realtimeReports',
    },
    TRANSACTIONS: {
        path: '/transactions',
    },
    TRANSACTION: {
        path: '/transactions/transaction',
    },
    LOGIN_LOGOUT: {
        path: '/transactions/loginLogout',
    },
    ACCOUNTING_PERIOD_RECORD: {
        path: '/transactions/accountingPeriodRecord',
    },
    EMAILS: {
        path: '/emails',
    },
    EMAIL_ADDRESSES: {
        path: `addresses`,
    },
    EMAIL_GROUPS: {
        path: `groups`,
    },
    OTHERS_CONFIG: {
        path: '/config/others',
    },
    LIVE_TV_CONFIG: {
        path: '/config/others/live-tv',
    },
    WEIGHT: {
        path: '/weight',
    },
    SPORTS: {
        path: 'sports',
    },
    CATEGORIES: {
        path: 'categories',
    },
    LEAGUES: {
        path: 'leagues',
    },
    TEAMS: {
        path: 'teams',
    },
    TRANSLATIONS: {
        path: '/translations',
    },
    SERVER_ERRORS: {
        path: '/translations/server-errors',
    },
    SERVER_ERRORS_RETAIL: {
        path: '/translations/server-errors/retail',
    },
    SERVER_ERRORS_ONLINE: {
        path: '/translations/server-errors/online',
    },
    USER_INTERFACE: {
        path: '/user-interface',
    },
    USER_INTERFACE_RETAIL: {
        path: 'retail',
    },
    USER_INTERFACE_ONLINE: {
        path: '/user-interface/online',
    },
    TERMINAL_LOGS: {
        path: '/logs/terminals/:terminalId',
    },
    UPDATE_VERSION: {
        path: '/update-version',
    },
    BANNERS: {
        path: '/banners',
    },
    BET_BANNER: {
        path: 'bet-banner',
    },
    PROMOTION_BANNER: {
        path: 'promotion-banner',
    },
    COUPON_BANNER: {
        path: 'coupon-banner',
    },
    FEATURED_LINKS: {
        path: '/featured-links',
    },
    LOGINS_HISTORY: {
        path: '/logins-history',
    },
    ACCOUNTING_REPORT: {
        path: '/accounting-report',
    },
    BANK: {
        path: '/bank',
    },
    DEPOSITS_WITHDRAWALS: {
        path: '/bank/deposits-withdrawals',
    },
    WITHDRAWAL_AUTOPROCESSING: {
        path: '/bank/withdrawal-autoprocessing-rules',
    },
    TAX_REPORT: {
        path: '/tax-report',
    },
    TAX_ON_RETURN_REPORT: {
        path: 'tax-on-return-report',
    },
    TAX_ON_TURNOVER_REPORT: {
        path: 'tax-on-turnover-report',
    },
    ONLINE_PLAYERS_REPORT: {
        path: '/online-players-report',
    },
    DECLINED_BETS_HISTORY: {
        path: '/declined-bets-history',
    },
    NET_CASH_REPORT: {
        path: '/net-cash-report',
    },
    FROZEN_ACCOUNTS_REPORT: {
        path: '/frozen-accounts-report',
    },
    REGISTRATION_HISTORY: {
        path: '/registrations-history',
    },
    PLAYER: {
        path: '/player',
    },
    SPORTS_PERFORMANCE: {
        path: '/player/sports-performance',
    },
    PLAYER_SEARCH: {
        path: '/player/player-search',
    },
    PLAYER_MASS_UPDATE: {
        path: '/player/mass-update',
    },
    MONEY_TRANSACTIONS: {
        path: '/bank/money-transactions',
    },
    PLAYER_ACTIVITY_REPORT: {
        path: '/player/player-activity-report',
    },
    TICKET_OPERATIONS_HISTORY: {
        path: '/ticket-operations-history',
    },
    BONUS_CREATION: {
        path: '/bonuses/bonus-creation',
    },
    PLAYER_SEGMENTATION: {
        path: '/player/player-segmentation',
    },
    PLAYER_SEGMENTATION_REPORT: {
        path: '/player/player-segmentation-report',
    },
    BULK_SEGMENT_UPDATE: {
        path: '/player/bulk-segment-update',
    },
    FEATURED: {
        path: '/featured',
    },
    INACTIVE_PLAYERS_REPORT: {
        path: '/inactive-players-report',
    },
    PLAYER_DETAILS: {
        path: '/player/player-details/:customerId',
    },
    PROMOTION_CREATION: {
        path: '/promotions/new',
    },
    PROMOTION_DETAILS: {
        path: '/promotions/:promotionId',
    },
    PROMOTIONS: {
        path: '/promotions',
    },
    PROMOTION_BONUS_OFFERS: {
        path: '/promotion-offers/:promotionId',
    },
    BONUSES: {
        path: '/bonuses',
    },
    PLAYER_BONUSES_REPORT: {
        path: '/player-bonuses-report',
    },
    BONUS_ENGINE_MONITOR: {
        path: '/bonus-engine-monitor',
    },
    GRAND_MASS_BONUSES: {
        path: '/grand-mass-bonuses',
    },
    BONUS_WAGERING_REPORT: {
        path: '/bonus-wagering-report',
    },
    AUDIT_TRAIL_REPORT: {
        path: '/audit-trail-report',
    },
    PAYMENT_METHODS: {
        path: '/configurations/payment-methods',
    },
    BETTING_RULES: {
        path: '/betting-rules',
    },
};

export const MENUS = {
    eventsCreation: { id: 1, subMenus: [2, 3, 4, 5, 6, 42, 45, 46, 47, 48, 49, 64, 133] },
    templates: { id: 2, subMenus: [3, 4, 5, 6, 42, 64, 133], path: ROUTES.TEMPLATES.path, name: 'Templates' },
    mbn: {
        id: 3,
        path: ROUTES.TEMPLATES_MBN.path,
        fullPath: concatWith('/', ROUTES.TEMPLATES.path, ROUTES.TEMPLATES_MBN.path),
        name: 'MBN',
    },
    coding: {
        id: 4,
        path: ROUTES.TEMPLATES_CODING.path,
        fullPath: concatWith('/', ROUTES.TEMPLATES.path, ROUTES.TEMPLATES_CODING.path),
        name: 'Coding',
    },
    marketGroups: {
        id: 5,
        path: ROUTES.TEMPLATES_MARKET_GROUPS.path,
        fullPath: concatWith('/', ROUTES.TEMPLATES.path, ROUTES.TEMPLATES_MARKET_GROUPS.path),
        name: 'Market Groups',
    },
    betAcceptance: {
        id: 6,
        path: ROUTES.TEMPLATES_BET_ACCEPTANCE.path,
        fullPath: concatWith('/', ROUTES.TEMPLATES.path, ROUTES.TEMPLATES_BET_ACCEPTANCE.path),
        name: 'Bet Acceptance Time',
    },
    monitoring: {
        id: 7,
        subMenus: [8, 9, 13, 26, 27, 28, 29, 30, 31, 32, 52, 60, 59, 61, 62, 63, 88, 130, 131, 132],
        name: 'Monitoring',
    },
    preMatch: { id: 8, path: ROUTES.EVENTS_PREMATCH.path, name: 'Pre-match' },
    live: { id: 9, path: ROUTES.EVENTS_LIVE.path, name: 'Live' },
    reports: {
        id: 10,
        subMenus: [11, 12, 14, 15, 16, 33, 39, 40, 41, 56, 58, 73, 74, 75, 79, 80, 81, 82, 83, 84, 86, 97, 110],
    },
    quickSearch: { id: 11, path: ROUTES.QUICK_SEARCH.path, name: 'Quick Search' },
    betHistory: { id: 12, path: ROUTES.BET_HISTORY.path, name: 'Bets History' },
    betsMonitor: { id: 13, path: ROUTES.BETS_MONITOR.path, name: 'Bets' },
    gamingActivity: { id: 14, path: ROUTES.GAMING_ACTIVITY.path, name: 'Gaming Activity' },
    accounts: { id: 17, subMenus: [18, 19, 22, 57, 70] },
    users: { id: 19, path: ROUTES.USERS.path, name: 'Users' },
    configurations: { id: 20, subMenus: [21, 23, 24, 34, 35, 36, 37, 38, 50, 51, 120, 123] },
    messages: { id: 23, subMenus: [50, 51] },
    ticketModal: { id: 25, path: '' },
    settlement: { id: 29, subMenus: [30, 31, 32], path: ROUTES.SETTLEMENT.path, name: 'Settlement' },
    settlementTickets: {
        id: 30,
        path: ROUTES.SETTLEMENT_TICKETS.path,
        fullPath: concatWith('/', ROUTES.SETTLEMENT.path, ROUTES.SETTLEMENT_TICKETS.path),
        name: 'Tickets',
    },
    settlementMarkets: {
        id: 32,
        path: ROUTES.SETTLEMENT_MARKETS.path,
        fullPath: concatWith('/', ROUTES.SETTLEMENT.path, ROUTES.SETTLEMENT_MARKETS.path),
        name: 'Markets',
    },
    emails: { id: 34, subMenus: [35, 36], path: ROUTES.EMAILS.path, name: 'Emails' },
    email_addresses: {
        id: 35,
        path: ROUTES.EMAIL_ADDRESSES.path,
        fullPath: concatWith('/', ROUTES.EMAILS.path, ROUTES.EMAIL_ADDRESSES.path),
        name: 'Addresses',
    },
    email_groups: {
        id: 36,
        path: ROUTES.EMAIL_GROUPS.path,
        fullPath: concatWith('/', ROUTES.EMAILS.path, ROUTES.EMAIL_GROUPS.path),
        name: 'Groups',
    },
    combinationLocks: {
        id: 42,
        path: ROUTES.TEMPLATES_LOCK_COMBINATIONS.path,
        fullPath: concatWith('/', ROUTES.TEMPLATES.path, ROUTES.TEMPLATES_LOCK_COMBINATIONS.path),
        name: 'Combination Lock',
    },
    translations: {
        id: 43,
        subMenus: [44, 53, 54, 55, 101, 102],
        path: ROUTES.TRANSLATIONS.path,
        name: 'Translations',
    },
    server_errors: { id: 44, subMenus: [102], path: ROUTES.SERVER_ERRORS.path, name: 'Server Errors' },
    weight: { id: 45, subMenus: [46, 47, 48, 49], path: ROUTES.WEIGHT.path, name: 'Weight' },
    sports: {
        id: 46,
        path: ROUTES.SPORTS.path,
        fullPath: concatWith('/', ROUTES.WEIGHT.path, ROUTES.SPORTS.path),
        name: 'Sports',
    },
    categories: {
        id: 47,
        path: ROUTES.CATEGORIES.path,
        fullPath: concatWith('/', ROUTES.WEIGHT.path, ROUTES.CATEGORIES.path),
        name: 'Categories',
    },
    leagues: {
        id: 48,
        path: ROUTES.LEAGUES.path,
        fullPath: concatWith('/', ROUTES.WEIGHT.path, ROUTES.LEAGUES.path),
        name: 'Leagues',
    },
    viewMessage: { id: 50, path: ROUTES.VIEW_MESSAGE.path, name: 'Message' },
    messageList: { id: 51, path: ROUTES.MESSAGE_LIST.path, name: 'Messages' },
    viewEvent: { id: 52, path: ROUTES.VIEW_EVENT.path, name: 'Event' },
    userInterface: { id: 53, subMenus: [55], path: ROUTES.USER_INTERFACE.path, name: 'User Interface' },
    userInterfaceOnline: {
        id: 55,
        path: ROUTES.USER_INTERFACE_ONLINE.path,
        name: 'User Interface',
    },
    markets: {
        id: 64,
        path: ROUTES.TEMPLATES_MARKETS.path,
        fullPath: concatWith('/', ROUTES.TEMPLATES.path, ROUTES.TEMPLATES_MARKETS.path),
        name: 'Markets',
    },
    cms: { id: 65, subMenus: [66, 67, 68, 69, 71, 96, 124], name: 'Cms' },
    banners: { id: 66, subMenus: [67, 68, 69], path: ROUTES.BANNERS.path, name: 'Banners' },
    betBanner: {
        id: 67,
        path: ROUTES.BET_BANNER.path,
        fullPath: concatWith('/', ROUTES.BANNERS.path, ROUTES.BET_BANNER.path),
        name: 'Bet Banners',
    },
    couponBanner: {
        id: 68,
        path: ROUTES.COUPON_BANNER.path,
        fullPath: concatWith('/', ROUTES.BANNERS.path, ROUTES.COUPON_BANNER.path),
        name: 'Coupon Banners',
    },
    promotionBanner: {
        id: 69,
        path: ROUTES.PROMOTION_BANNER.path,
        fullPath: concatWith('/', ROUTES.BANNERS.path, ROUTES.PROMOTION_BANNER.path),
        name: 'Promotion Banners',
    },
    featuredLinks: { id: 71, path: ROUTES.FEATURED_LINKS.path, name: 'Featured Links' },
    loginsHistory: { id: 73, path: ROUTES.LOGINS_HISTORY.path, name: 'Logins History' },
    accountingReport: { id: 74, path: ROUTES.ACCOUNTING_REPORT.path, name: 'Accounting Report' },
    onlinePlayersReport: { id: 75, path: ROUTES.ONLINE_PLAYERS_REPORT.path, name: 'Online Players Report' },
    bank: { id: 76, subMenus: [77, 78, 91], name: 'Bank' },
    depositsWithdrawals: { id: 77, path: ROUTES.DEPOSITS_WITHDRAWALS.path, name: 'Deposits/Withdrawals' },
    withdrawalAutoprocessing: {
        id: 78,
        path: ROUTES.WITHDRAWAL_AUTOPROCESSING.path,
        name: 'Withdrawal Autoprocessing Rules',
    },
    taxReport: { id: 79, subMenus: [80, 81], path: ROUTES.TAX_REPORT.path, name: 'Tax Report' },
    taxOnReturnReport: {
        id: 80,
        path: ROUTES.TAX_ON_RETURN_REPORT.path,
        fullPath: concatWith('/', ROUTES.TAX_REPORT.path, ROUTES.TAX_ON_RETURN_REPORT.path),
        name: 'Tax On Return Report',
    },
    taxOnTurnoverReport: {
        id: 81,
        path: ROUTES.TAX_ON_TURNOVER_REPORT.path,
        fullPath: concatWith('/', ROUTES.TAX_REPORT.path, ROUTES.TAX_ON_TURNOVER_REPORT.path),
        name: 'Tax On Turnover Report',
    },
    netCashReport: { id: 82, path: ROUTES.NET_CASH_REPORT.path, name: 'Net Cash Report' },
    declinedBetsHistory: { id: 83, path: ROUTES.DECLINED_BETS_HISTORY.path, name: 'Declined Bets History' },
    frozenAccountsReport: { id: 84, path: ROUTES.FROZEN_ACCOUNTS_REPORT.path, name: 'Frozen Accounts Report' },
    bonus: { id: 85, subMenus: [95, 98, 99, 100, 103, 104, 105, 106, 107, 108, 109], name: 'Bonus' },
    registrationsHistory: { id: 86, path: ROUTES.REGISTRATION_HISTORY.path, name: 'Registrations History' },
    player: { id: 87, subMenus: [89, 90, 92, 93, 94, 121, 122], name: 'Player' },
    sportsPerformance: { id: 88, path: ROUTES.SPORTS_PERFORMANCE.path, name: 'Sports Performance' },
    playerSearch: { id: 89, path: ROUTES.PLAYER_SEARCH.path, name: 'Player Search' },
    playerMassUpdate: { id: 90, path: ROUTES.PLAYER_MASS_UPDATE.path, name: 'Player Mass Update' },
    moneyTransactions: { id: 91, path: ROUTES.MONEY_TRANSACTIONS.path, name: 'Money Transactions' },
    playerSegmentation: { id: 92, path: ROUTES.PLAYER_SEGMENTATION.path, name: 'Player Segmentation' },
    playerActivityReport: { id: 93, path: ROUTES.PLAYER_ACTIVITY_REPORT.path, name: 'Player Activity Report' },
    playerDetails: { id: 94, path: ROUTES.PLAYER_DETAILS.path, name: 'Player Details' },
    bonusCreation: {
        id: 95,
        path: ROUTES.BONUS_CREATION.path,
        name: 'Bonus Creation',
    },
    featured: { id: 96, path: ROUTES.FEATURED.path, name: 'Featured' },
    inactivePlayersReport: { id: 97, path: ROUTES.INACTIVE_PLAYERS_REPORT.path, name: 'Inactive Players' },
    promotionCreation: { id: 98, path: ROUTES.PROMOTION_CREATION.path, name: 'Promotion' },
    bonuses: { id: 99, path: ROUTES.BONUSES.path, name: 'Bonuses' },
    promotions: { id: 100, path: ROUTES.PROMOTIONS.path, name: 'Promotions' },
    serverErrorsOnline: { id: 102, path: ROUTES.SERVER_ERRORS_ONLINE.path, name: 'Server Errors' },
    promotionDetails: { id: 103, path: ROUTES.PROMOTION_DETAILS.path, name: 'Promotion Details' },
    // bonusDetails: { id: 104, path: ROUTES.BONUS_DETAILS.path, name: 'Bonus' },
    bonusWageringReport: { id: 105, path: ROUTES.BONUS_WAGERING_REPORT.path, name: 'Bonus Wagering Report' },
    bonusEngineMonitor: { id: 106, path: ROUTES.BONUS_ENGINE_MONITOR.path, name: 'Bonus Engine Monitor' },
    playerBonusesReport: { id: 107, path: ROUTES.PLAYER_BONUSES_REPORT.path, name: 'Player Bonuses Report' },
    grandMassBonuses: { id: 108, path: ROUTES.GRAND_MASS_BONUSES.path, name: 'Grand Mass Bonuses' },
    promotionBonusOffers: { id: 109, path: ROUTES.PROMOTION_BONUS_OFFERS.path, name: 'Promotion Bonus Offers' },
    auditTrailReport: { id: 110, path: ROUTES.AUDIT_TRAIL_REPORT.path, name: 'Audit Trail Report' },
    ticketOperationsHistory: {
        id: 111,
        path: ROUTES.TICKET_OPERATIONS_HISTORY.path,
        name: 'Ticket Operations History',
    },
    ticketCodeVisibility: { id: 117, path: '' },
    menuManagement: {
        id: 120,
        name: 'Menu Management',
        path: ROUTES.MENU_MANAGEMENT.path,
    },
    bulkSegmentUpdate: {
        id: 121,
        path: ROUTES.BULK_SEGMENT_UPDATE.path,
        name: 'Bulk Segment Update',
    },
    playerSegmentationReport: {
        id: 122,
        path: ROUTES.PLAYER_SEGMENTATION_REPORT.path,
        name: 'Player Segmentation Report',
    },
    paymentMethods: {
        id: 123,
        name: 'Payment Methods',
        path: ROUTES.PAYMENT_METHODS.path,
    },
    bettingRules: {
        id: 124,
        name: 'Betting Rules',
        path: ROUTES.BETTING_RULES.path,
    },
    cashoutBlock: {
        id: 130,
        subMenus: [131, 132],
        path: ROUTES.CASHOUT_BLOCK.path,
        name: 'Cashout Block',
    },
    cashoutBlockEvents: {
        id: 131,
        path: ROUTES.CASHOUT_BLOCK_EVENTS.path,
        fullPath: concatWith('/', ROUTES.CASHOUT_BLOCK.path, ROUTES.CASHOUT_BLOCK_EVENTS.path),
        name: 'Events',
    },
    cashoutBlockMarketsAndLeagues: {
        id: 132,
        path: ROUTES.CASHOUT_BLOCK_MARKETS_AND_LEAGUES.path,
        fullPath: concatWith('/', ROUTES.CASHOUT_BLOCK.path, ROUTES.CASHOUT_BLOCK_MARKETS_AND_LEAGUES.path),
        name: 'Markets and Leagues',
    },
    marketDescriptions: {
        id: 133,
        path: ROUTES.TEMPLATES_MARKET_DESCRIPTIONS.path,
        fullPath: concatWith('/', ROUTES.TEMPLATES.path, ROUTES.TEMPLATES_MARKET_DESCRIPTIONS.path),
        name: 'Market Descriptions',
    },

    updateVersion: { id: 1000, path: ROUTES.UPDATE_VERSION.path, name: 'Update Version' },
};

export const ROUTE_ALIASES: Record<string, string> = {
    '/bets-history-2': ROUTES.BET_HISTORY.path,
    '/accounts/users-2': ROUTES.USERS.path,
    '/gaming-activity-2': ROUTES.GAMING_ACTIVITY.path,
};

export const findMatchedMenu = pathname => {
    let matchedMenu;

    Object.values(MENUS).map(menu => {
        let menuPath = menu.fullPath ? menu.fullPath : menu.path;

        if (matchPath(menuPath ?? '', pathname)) {
            matchedMenu = { ...menu, fullPath: pathname };
        }
    });

    if (!matchedMenu) {
        const aliasTarget = Object.entries(ROUTE_ALIASES).find(([alias]) => matchPath(alias, pathname))?.[1];

        if (aliasTarget) {
            Object.values(MENUS).map(menu => {
                let menuPath = menu.fullPath ? menu.fullPath : menu.path;

                if (matchPath(menuPath ?? '', aliasTarget)) {
                    matchedMenu = { ...menu, fullPath: pathname };
                }
            });
        }
    }

    return matchedMenu;
};

export const generatePath = (route, params) => {
    if (!params) return route;

    let generatedRoute = route;

    Object.entries(params).map(([key, value]) => {
        generatedRoute = generatedRoute.replace(`:${key}`, value);
    });

    return generatedRoute;
};

export default ROUTES;
